import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const reimportCopDocument = api(async function reimportCopDocument({ id }) {
    return mutate(
        gql`
            mutation ReimportCopDocument($id: ID!) {
                reimportCopDocument(id: $id)
            }
        `,
        { id },
        { returns: "reimportCopDocument" }
    )
})
